import { buildComponent } from '#components'

export const NewsletterForm = buildComponent({
  name: 'newsletter-form',
  onConnected: (component: HTMLElement) => {
    const emailInput = component.querySelector<HTMLInputElement>('.js-newsletter-email')
    const errorMessage = component.querySelector<HTMLElement>('#newsletter-email-error')
    const submitButton = component.querySelector<HTMLButtonElement>('.js-newsletter-submit')

    function validateEmail(email: string): boolean {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      return emailPattern.test(email)
    }

    function showError(message: string) {
      if (errorMessage) errorMessage.textContent = message
      emailInput?.setAttribute('aria-invalid', 'true')
      submitButton?.setAttribute('disabled', 'true')
    }

    function clearError() {
      if (errorMessage) errorMessage.textContent = ''
      emailInput?.removeAttribute('aria-invalid')
      submitButton?.removeAttribute('disabled')
    }

    function debounce<T extends (...args: unknown[]) => void>(func: T, wait: number) {
      let timeout: ReturnType<typeof setTimeout>

      return (...args: Parameters<T>) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => func(...args), wait)
      }
    }

    const validateOnInput = debounce(() => {
      if (!emailInput?.value.trim()) {
        showError('Please enter your email address.')
      } else if (!validateEmail(emailInput.value.trim())) {
        showError('Please enter a valid email address.')
      } else {
        clearError()
      }
    }, 400)

    emailInput?.addEventListener('input', validateOnInput)
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'newsletter-form': typeof NewsletterForm
  }
}
